import React from 'react';
import { Row, Switch } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useTFAContext } from './context';
import { DeactivateTokenModal } from './DeactivateTokenModal';
import { Field, Information } from '../../styles';

export const TwoFactorAuthentication: React.FC = () => {
	const { handleOpenGenerateTokenModal, handleOpenDeactivateTokenModal } = useTFAContext();
	const { checked2FA, user2FA, fecthingUser2FA, openGenerateTokenModal, openDeactivateTokenModal } = useTFAContext();

	function handleOnChange(): void {
		if (!user2FA.validated) {
			handleOpenGenerateTokenModal(!openGenerateTokenModal);
		} else {
			handleOpenDeactivateTokenModal(!openDeactivateTokenModal);
		}
	}

	return (
		<>
			<Field>{I18n.get('Two-factor authentication')}</Field>
			<Information>
				{I18n.get('When activated, you will have to type a validation code every time you login.')}
			</Information>
			<Row style={{ marginTop: '25px' }}>
				<Switch
					loading={fecthingUser2FA}
					defaultChecked={!!user2FA.validated}
					checked={!!user2FA.validated || checked2FA}
					onChange={handleOnChange}
				/>
				<Information style={{ marginLeft: '13px' }}>
					{user2FA.validated || checked2FA ? I18n.get('Deactivate') : I18n.get('Activate')}
				</Information>
			</Row>

			{openDeactivateTokenModal && <DeactivateTokenModal />}
		</>
	);
};
